export default __webpack_public_path__ + "static/media/food08.79ca7412.png";